import { CalendarDaysIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { TableStateLayout } from '../../shared/TableStateLayout';

interface OverviewEmptyStateProps {
    title: string;
    text: string;
    filtersActive: boolean;
    onClearFilters: () => void;
}

export function OverviewEmptyState({
    title,
    text,
    filtersActive,
    onClearFilters
}: OverviewEmptyStateProps) {
    return filtersActive ? (
        <TableStateLayout
            icon={CalendarDaysIcon}
            title={title}
            text="Nothing matches the search and filters. Clear them to see every VA."
            actionLabel="Clear filters"
            onAction={onClearFilters}
        />
    ) : (
        <TableStateLayout icon={CalendarDaysIcon} title={title} text={text} />
    );
}

export function OverviewErrorState({ onRetry }: { onRetry: () => void }) {
    return (
        <TableStateLayout
            icon={ExclamationTriangleIcon}
            title="Couldn't load virtual appointments"
            text="Something went wrong fetching the list. Try again."
            actionLabel="Retry"
            onAction={onRetry}
        />
    );
}
